import script from "./GridRolComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridRolComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridRolComponent.vue?vue&type=style&index=0&id=5ef55830&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef55830"]])

export default __exports__